export const SET_FULL_URL = 'SET_FULL_URL';
export const SET_VK_PARAMS = 'SET_VK_PARAMS';
export const SET_VK_APP_SETTINGS = 'SET_VK_APP_SETTINGS';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';